import { render, staticRenderFns } from "./AdminStructure.vue?vue&type=template&id=40bf2c26"
import script from "./AdminStructure.vue?vue&type=script&lang=js"
export * from "./AdminStructure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports